import { h, PropType, defineComponent } from 'vue';
import { State } from '@frontend/state';
import BarButton from '@components/bar-button';
import { show_viewport_manager } from '@features/save-viewpoint/state';
import icon from '../../../../../frontend/phi3d/src/assets/img/SVG_icons/Bottom/visualisation/save_recall_viewpoint.svg';
import { coming_soon } from '@components/icons';
import { img } from '@phi/components';
import SaveViewpointTooltip from './SaveViewpointTooltip';

export const SaveRecallViewpointIcon = icon;

export const SaveRecallViewpoint = defineComponent({
    props: {
        state: {
            required: true,
            type: Object as PropType<State>,
        },
    },

    computed: {
        disabled() {
            return !this.state.loaded;
        },

        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Save/recall viewpoint';
        },
    },

    methods: {
        onClick() {
            if (this.disabled)
                return;
            else
                show_viewport_manager();
        }
    },

    render() {
        return h(BarButton, {
            disabled: this.disabled,
            selected: this.state.tut_stage === 3,
            active: false,
            id: 'save-recall-viewpoint-button',
            tippy: 'top',
            onClick: this.onClick,
        }, {
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(icon, this.alt),
            tooltip: SaveViewpointTooltip,
        });
    }
});
